import { validatePhoneE164 } from '@insify/global-validation';
import { emailRegex } from '@insify/ui-utils';
import * as yup from 'yup';

import type { HighCareProps } from './types';

export const validation = (translations: HighCareProps['translations'], disableCompanyName: boolean) =>
  yup.object().shape({
    ...(disableCompanyName
      ? {}
      : {
          companyName: yup.string().required(translations.validation.required),
        }),
    representative: yup.object().shape({
      email: yup.string().required(translations.validation.required).matches(emailRegex, translations.validation.email),
      phone: yup
        .string()
        .required(translations.validation.required)
        .test('phone', translations.validation.phone, validatePhoneE164),
    }),
  });
